import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import { EPlatform } from '@/utils/enums/platform-enum';
import Image from 'next/image';
import Link from 'next/link';
import { useContext, useEffect } from 'react';

// 法语静态内容组件
export default function FrenchContent() {
  // const supportEmail = env.NEXT_PUBLIC_SUPPORT_EMAIL;
  const { deviceType } = useContext(ResponsiveContext);
  const setIsShowFooterNav = useStore((state) => state.setIsShowFooterNav);

  useEffect(() => {
    const isMobile = deviceType !== EPlatform.WEB;
    isMobile && setIsShowFooterNav(false);
  }, [deviceType]);
  return (
    <>
      <WebOnly>
        <div className="w-full py-[50px] px-[200px] text-[14px] font-ir">
          <p className="text-left my-[25px] leading-[24px]">
            <span>
              Zeelool a pour objectif de vos fournor une paire de lunettes parfaite au leilleur
              prix. Si vous rencontrez desproblemèmes, n&#39;hésitez pas à nous contacter.
            </span>
            <br />
            <span>
              Notre equipe de service à la clientèle vous fournira une solution raisonnable à toutes
              sortes de problèmes avec les lunettes dans les 30 jours suivant la réception des
              lunettes. Notre service clientèle vous propose une solution raisonnable pour toutes
              sortes de déproblemèmes avec les lunettes dans les 30 jours à compter de la date à
              laquelle vous recevez les lunettes.
            </span>
          </p>

          <div className="relative mb-[50px]">
            <Image
              src="https://cdn.shoplazza.com/0cd6beca837fe4835e8053a631fdcbc5.jpeg"
              alt="rétraction et rembrousement"
              width={800}
              height={400}
              className="w-full"
            />
            <h1 className="absolute top-1/2 left-1/2 w-full transform -translate-x-1/2 -translate-y-full text-center text-[36px] text-white font-bb">
              <span>rétraction et rembrousement</span>
            </h1>
          </div>

          <div>
            <p className="mb-[40px] mx-auto leading-[24px]">
              En cas de troubles, vous disposez d&#39;un délai de 30 jours à compter de la réception
              de vos lunettes afin d&#39;obtenir l&#39;aide nécessaire et une solution à vos
              attentes.
            </p>

            <p className="mb-[40px] mx-auto leading-[24px]">
              <span>À propos de la prescription:</span>
              <span>&nbsp;</span>si les lunettes ne sont pas claires, veuillez d&#39;abord vérifier
              votre prescription. Si la prescription est correcte, vous pouvez nous la renvoyer pour
              inspection dans la période de garantie de 30 jours et nous vous donnerons un
              remplacement ou un remboursement si cela est de notre responsabilité; si vous
              remplissez la prescription incorrecte, vous pouvez obtenir un coupon spécial pour vos
              nouvelles lunettes ou vous pouvez obtenir un remboursement (hors frais de transport et
              de verres).
            </p>
            <p className="mb-[40px] mx-auto leading-[24px]">
              Recevez des lunettes incorrectes: si vous vous trompez de lunettes qui ne
              correspondent pas à celles que vous avez commandées, vous devez fournir une photo des
              lunettes incorrectes, nous vous renverrons une nouvelle paire de lunettes gratuitement
              après vérification et vous pourrez conserver les lunettes incorrectes reçues .
            </p>
            <p className="mb-[40px] mx-auto leading-[24px]">
              Les lunettes perdues: Dans les cas suivants, nous réémettons la commande originale
              sans condition: le client a fourni une preuve claire de la perte; le bureau de poste a
              montré une livraison correcte et le client a contacté la poste locale à plusieurs
              reprises sans résultat; il y avait le délai de livraison et le numéro de la feuille de
              route, mais aucune information logistique.
            </p>
            <p className="mb-[40px] mx-auto leading-[24px]">
              Avaries au transport: Si les lunettes sont avariées en raison du transport, nous les
              remplacerons gratuitement ou vous rembourserons partiellement.
            </p>
            <p className="mb-[40px] mx-auto leading-[24px]">
              Avaries dans les 30 jours: la re-livraison gratuite est disponible dans les 30 jours
              suivant l&#39;arrivée de la cargaison en cas de perte non prévu. Cette garantie ne
              couvre pas l&#39;usure normale des montures, verres ou revêtements.
            </p>
            <p className="mb-[40px] mx-auto leading-[24px]">
              Pertes dans les 3 mois: s&#39;il est avarié par des facteurs non humains et ne peut
              pas être utilisé normalement dans les 3 mois (à l&#39;exclusion de l&#39;usure
              normale), veuillez contacter notre centre de service clientèle pour vous aider à
              résoudre ce problème. Si c&#39;est plus de 3 mois, nous vous offrirons la meilleure
              remise pour votre prochain achat.
            </p>
            <h3 className="mb-[40px] text-[20px]">
              Recette supplémentaire/mise à jour de recette/modification de commande/annulation de
              commande
            </h3>
            <p className="mb-[40px] mx-auto leading-[24px]">
              Etant donné que toutes les lunettes sont ajustées selon la prescription donnée,aucune
              annulation/modification gratuite n&#39;est prévue pour les lunettes.Les frais
              d&#39;expédition et les différences ne sont pas inclus,le cas échéant.Dans les
              situations ci-dessus,calculez les frais comme suit.
            </p>
            {/* More French content... */}

            <table className="my-[20px] mx-auto border-collapse border-spacing-0 w-[755px] border border-[#ddd]">
              <tbody>
                <tr className="bg-[#eaedf6]">
                  <td className="bg-[#d6dae5] border border-[#ddd] text-center h-[60px] align-middle break-words w-[116px]" />
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[180px]">
                    Avant d&#39;expédition
                  </td>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[459px]">
                    Après expédition
                  </td>
                </tr>
                <tr>
                  <td className=" border border-[#ddd] text-center h-[60px] align-middle break-words w-[116px]">
                    Monture uniquement
                  </td>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[180px]">
                    Libérer
                  </td>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[459px]">
                    30% du prix de la monture
                  </td>
                </tr>
                <tr>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[116px]">
                    Lunettes correctives
                  </td>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[180px]">
                    10% du montant de la commande
                  </td>
                  <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[459px]">
                    30% du prix de la monture + 50% du prix des verres
                  </td>
                </tr>
              </tbody>
            </table>

            <p className="mb-[80px] mx-auto leading-[24px]">
              <span>Noter:&nbsp;</span>Ici, vous pouvez suivre l&#39;état de votre commande -
              <span>&nbsp;</span>
              <Link href="/track-order" className="text-[#3c65c8]">
                Suivi de commande
              </Link>
            </p>

            <div className="flex">
              <div className="left">
                <Image
                  src="https://cdn.shoplazza.com/d61e587bf685b52067ff941266eef9be.jpeg"
                  alt="Comment retourner vos lunettes"
                  width={276}
                  height={200}
                />
              </div>
              <div className="flex flex-col justify-center w-[calc(100%-276px)] leading-[24px] bg-[#f4f6f8] p-[20px_30px] box-border">
                <h3 className="mt-[30px] mb-[20px] text-[20px]">
                  <span>Comment retourner vos lunettes</span>
                </h3>
                <p className="m-0">
                  <span>·</span>Contactez-nous par e-mail à support-fr@zeelool.com dans les 30 jours
                  suivant la réception de vos lunettes. Tous les retours doivent être retournés dans
                  leur état d&#39;origine non porté.
                </p>
                <p className="m-0">
                  <span>·</span>Emballez vos lunettes en toute sécurité et laissez une note avec
                  votre nom, votre numéro de commande et une brève description de la raison du
                  retour; ou avoir reçu une copie de l&#39;ordonnance de votre médecin afin que
                  Zeelool puisse examiner les lunettes.
                </p>
                <p className="m-0">
                  <span>·</span>Zeelool serait désolé si vos lunettes étaient perdues pendant le
                  transport. Par conséquent, il est recommandé d&#39;expédier vos retours par une
                  méthode traçable. Veuillez nous envoyer le numéro de suivi lorsque vous nous
                  envoyez les lunettes.
                </p>
                <p className="m-0">
                  <span>·</span>Une fois que Zeelool reçoit les articles retournés, vous serez
                  remboursé dans les 3 jours ouvrables.
                </p>
                <p className="m-0">
                  <span>·</span>Remarque: Nous ne prenons pas en charge les frais de retour (autre
                  que notre responsabilité) et vous devez le payer vous-même.
                </p>
                <p className="m-0">
                  <span>.</span>Les frais de port peuvent être remboursés dans les situations
                  suivantes: retard de livraison, mauvais styles.
                </p>
                <p className="m-0">
                  <span>.</span>Les frais d&#39;expédition ne peuvent pas être remboursés dans les
                  situations ci-dessous: je n&#39;aime pas, problème de largeur, mauvaise
                  prescription / adresse remplie.
                </p>
              </div>
            </div>
          </div>
        </div>
      </WebOnly>

      <WapOnly>
        <div className="px-[16px]">
          <div className="text-[14px] font-ir">
            <div className="container">
              <p className="my-[20px] leading-[1.5]">
                Zeelool a pour objectif de vos fournor une paire de lunettes parfaite au leilleur
                prix. Si vous rencontrez desproblemèmes, n&#39;hésitez pas à nous contacter. <br />
                Notre service clientèle vous propose une solution raisonnable pour toutes sortes de
                déproblemèmes avec les lunettes dans les 30 jours à compter de la date à laquelle
                vous recevez les lunettes.
              </p>

              <p className="text-[20px]">rétraction et rembrousement</p>

              <p className="leading-[1.5] my-[20px]">
                En cas de troubles, vous disposez d&#39;un délai de 30 jours à compter de la
                réception de vos lunettes afin d&#39;obtenir l&#39;aide nécessaire et une solution à
                vos attentes.
              </p>
              <p className="mb-[20px]">
                À propos de la prescription: si les lunettes ne sont pas claires, veuillez
                d&#39;abord vérifier votre prescription. Si la prescription est correcte, vous
                pouvez nous la renvoyer pour inspection dans la période de garantie de 30 jours et
                nous vous donnerons un remplacement ou un remboursement si cela est de notre
                responsabilité; si vous remplissez la prescription incorrecte, vous pouvez obtenir
                un coupon spécial pour vos nouvelles lunettes ou vous pouvez obtenir un
                remboursement (hors frais de transport et de verres).
              </p>
              <p className="mb-[20px]">
                À propos de la largeur: il y aura un écart d&#39;environ 1 à 2 mm dans les
                paramètres de la monture en raison de différentes techniques de mesure et
                d&#39;angles, les paramètres réels devant prévaloir en nature. Cependant, si les
                lunettes ne conviennent pas parce que vous avez lu accidentellement des informations
                de largeur incorrectes, vous devez nous contacter pour résoudre le problème dans les
                30 jours suivant la réception des lunettes. Notre service clientèle vous donnera une
                solution raisonnable pour les échanger ou un code de réduction pour de nouvelles
                lunettes.
              </p>
              <p className="mb-[20px]">
                Les lunettes perdues: Dans les cas suivants, nous réémettons la commande originale
                sans condition: le client a fourni une preuve claire de la perte; le bureau de poste
                a montré une livraison correcte et le client a contacté la poste locale à plusieurs
                reprises sans résultat; il y avait le délai de livraison et le numéro de la feuille
                de route, mais aucune information logistique.
              </p>
              <p className="mb-[20px]">
                Avaries au transport: Si les lunettes sont avariées en raison du transport, nous les
                remplacerons gratuitement ou vous rembourserons partiellement.
              </p>
              <p className="mb-[20px]">
                Avaries dans les 30 jours: la re-livraison gratuite est disponible dans les 30 jours
                suivant l&#39;arrivée de la cargaison en cas de perte non prévu. Cette garantie ne
                couvre pas l&#39;usure normale des montures, verres ou revêtements.
              </p>
              <p className="mb-[20px]">
                Pertes dans les 3 mois: s&#39;il est avarié par des facteurs non humains et ne peut
                pas être utilisé normalement dans les 3 mois (à l&#39;exclusion de l&#39;usure
                normale), veuillez contacter notre centre de service clientèle pour vous aider à
                résoudre ce problème. Si c&#39;est plus de 3 mois, nous vous offrirons la meilleure
                remise pour votre prochain achat.
              </p>
              <p className="mb-[20px]">
                Recette supplémentaire/mise à jour de recette/modification de commande/annulation de
                commande
              </p>
              <p className="mb-[20px]">
                Pour les lunettes sans ordonnance, nous acceptons une prescription
                supplémentaire/une modification de commande/une annulation de commande avant
                d&#39;expédier votre commande.En ce qui concerne la commande de mise à jour de la
                prescription,vous devez nous en informer avant de traiter les verres.En cas de
                différences de prix,des frais supplémentaires seront facturés.Veuillez nous
                contacter dans les plus brefs délais afin que nous puissions traiter votre commande
                de manière appropriée et en temps utile.
              </p>
              <p className="mb-[20px]">
                Si vous souhaiter modifier ou annuler votre commande, veuillez contacter notre
                service clientèle dans les 24 heures pour éviter des frais
                supplémentaires.Sinon,veuillez vous référer au tableau ci-dessous pour vérifier les
                délais.Etant donné que toutes les lunettes sont ajustées selon la prescription
                donnée,aucune annulation/modification gratuite n&#39;est prévue pour les
                lunettes.Les frais d&#39;expédition et les différences ne sont pas inclus,le cas
                échéant.Dans les situations ci-dessus,calculez les frais comme suit.
              </p>
              {/* More French mobile content... */}

              <table className="my-[20px] mx-auto border-collapse border-spacing-0 w-full text-[12px] border border-[#ddd]">
                <tbody>
                  <tr className="bg-[#eaedf6]">
                    <td className="bg-[#d6dae5] border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]" />
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Avant d&#39;expédition
                    </td>
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Après expédition
                    </td>
                  </tr>
                  <tr>
                    <td className="bg-[#eaedf6] border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      MONTURE UNIQUEMENT
                    </td>
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Libérer
                    </td>
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      30% du prix de la monture
                    </td>
                  </tr>
                  <tr>
                    <td className="bg-[#eaedf6] border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Lunettes correctives
                    </td>
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      10% du montant de la commande
                    </td>
                    <td className="border border-[#ddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      30% du prix de la monture + 50% du prix des verres
                    </td>
                  </tr>
                </tbody>
              </table>

              <p className="leading-[1.5] my-[20px]">
                Noter: Ici, vous pouvez suivre l&#39;état de votre commande -
                <Link href="/track-order" className="text-[#3c65c8] font-bb">
                  Suivi de commande
                </Link>
              </p>

              <p className="text-[20px]">Comment retourner vos lunettes</p>

              <p className="leading-[1.5] my-[20px]">
                <span>·</span>Contactez-nous par e-mail à support-fr@zeelool.com dans les 30 jours
                suivant la réception de vos lunettes. Tous les retours doivent être retournés dans
                leur état d&#39;origine non porté.
              </p>
              <p className="mb-[20px]">
                <span>·</span>Emballez vos lunettes en toute sécurité et laissez une note avec votre
                nom, votre numéro de commande et une brève description de la raison du retour; ou
                avoir reçu une copie de l&#39;ordonnance de votre médecin afin que Zeelool puisse
                examiner les lunettes.
              </p>
              <p className="mb-[20px]">
                <span>·</span>Zeelool serait désolé si vos lunettes étaient perdues pendant le
                transport. Nous vous recommandons donc d&#39;envoyer vos retours en utilisant une
                méthode traçable. Veuillez nous envoyer le numéro de suivi lorsque vous nous envoyez
                les lunettes
              </p>
              <p className="mb-[20px]">
                <span>·</span>
                <span>
                  Une fois que Zeelool reçoit les articles retournés, vous serez remboursé dans les
                  3 jours ouvrables.
                </span>
              </p>
              <p className="mb-[20px]">
                <span>·</span>Remarque: Nous ne prenons pas en charge les frais de retour (autre que
                notre responsabilité) et vous devez le payer vous-même.
              </p>
              <p className="mb-[20px]">
                <span>.</span>Les frais de port peuvent être remboursés dans les situations
                suivantes: retard de livraison, mauvais styles.
              </p>
              {/* More French mobile content... */}
            </div>
          </div>
        </div>
      </WapOnly>
    </>
  );
}
